import { ColumnDef, Row } from "@tanstack/react-table"
import { UsersAdminTableDataI } from "../types"
import ToolTip from "../../shared/toolTip/tooltip"
import { Link } from "react-router-dom"
import classNames from "classnames"
import styles from "./column.module.scss"
import ToolTip_Popover from "../../shared/toolTip/toolTip_popover"

export const FULL_NAME_COLUMN_ID = "fullName"
export const EMAIL_COLUMN_ID = "email"
export const ORGANIZATION_COLUMN_ID = "organization"
export const ROLE_COLUMN_ID = "role"
export const STATUS_COLUMN_ID = "userStatus"
export const ACCESS_COLUMN_ID = "access"
export const MENU_COLUMN_ID = "menu"

const usersAdminColumns: ColumnDef<UsersAdminTableDataI>[] = [
    {
        accessorKey: FULL_NAME_COLUMN_ID,
        header: "Name",
        enableMultiSort: false,
        enableSorting: true,
        sortDescFirst: false,
        sortingFn: "alphanumeric",
        cell: ({ row }) => {
            return (
                <ToolTip
                    tooltipContent={<div>{row.original.fullName}</div>}
                    triggerChildren={
                        <Link
                            className={classNames(styles.link)}
                            to={`${row.original.subjectId}/update`}
                            state={{
                                email: row.original.email,
                                organizationName: row.original.organization,
                                firstName: row.original.firstName,
                                lastName: row.original.lastName,
                                userRole: row.original.role,
                                activeUser: row.original.active,
                            }}
                        >
                            {row.original.fullName}
                        </Link>
                    }
                />
            )
        },
    },
    {
        accessorKey: EMAIL_COLUMN_ID,
        header: "Email",
        enableMultiSort: false,
        enableSorting: true,
        sortDescFirst: false,
        sortingFn: "alphanumeric",
        cell: ({ row }) => {
            const email = row.original.email
            return (
                <ToolTip_Popover
                    content={<>{email}</>}
                    triggerChildren={
                        <div className={styles.triggerChildren}>{email}</div>
                    }
                    popover={{
                        removePopoverButtonStyling: true,
                        triggerStyles: styles.triggerStyles,
                    }}
                    customTooltipContentStyles={
                        styles.customTooltipContentStyles
                    }
                />
            )
        },
    },
    {
        accessorKey: ORGANIZATION_COLUMN_ID,
        header: "Organization",
        enableColumnFilter: true,
        enableSorting: true,
        sortDescFirst: false,
        sortingFn: "alphanumeric",
        cell: ({ row }) => {
            const organization = row.original.organization
            return (
                <ToolTip_Popover
                    content={<>{organization}</>}
                    triggerChildren={
                        <div className={styles.triggerChildren}>
                            {organization}
                        </div>
                    }
                    popover={{
                        removePopoverButtonStyling: true,
                        triggerStyles: styles.triggerStyles,
                    }}
                    customTooltipContentStyles={
                        styles.customTooltipContentStyles
                    }
                />
            )
        },
    },
    {
        accessorKey: ROLE_COLUMN_ID,
        header: "Role",
        enableColumnFilter: false,
        enableSorting: false,
        sortingFn: "alphanumeric",
        cell: ({ row }) => {
            return <>{row.original.role}</>
        },
    },
    {
        accessorKey: STATUS_COLUMN_ID,
        header: "Status",
        enableSorting: false,
        sortDescFirst: false,
        sortingFn: "alphanumeric",
        filterFn: (row, _columnId, filterValue) => {
            // when filter value is true, show only active users
            if (filterValue === true) {
                return row.original.active === true
            }
            // when filter is false, show all users
            return true
        },
        cell: ({ row }) => (row.original.active ? "Active" : "Inactive"),
    },
    {
        accessorKey: ACCESS_COLUMN_ID,
        header: "Well Access",
        enableSorting: true,
        sortDescFirst: false,
        sortingFn: (rowA: Row<UsersAdminTableDataI>) => {
            return rowA.original.managedAccess ? 1 : -1
        },
        cell: ({ row }) => {
            return (
                <Link
                    to={`${row.original.organizationMembershipId}/access`}
                    className={styles.link}
                >
                    {row.original.managedAccess
                        ? "Limited Access"
                        : "Full Access"}
                </Link>
            )
        },
    },
]

export default usersAdminColumns
